import React, { useState } from 'react';
import './LearnAbout.css';
import Button from '../Button/Button';

const LearnAbout = ({ links, title }) => {
  // State to manage the selected link details
  const [selectedLink, setSelectedLink] = useState(links[0]);

  return (
   <div className='learnabout-main'>
     <div className="learnabout-container">
      {/* Left Navigation Links */}
      <div className="learnabout-links">
        <h2>{title}</h2>
        <ul>
          {links?.map((link, index) => (
            <li
              key={index}
              className={`learnabout-link-item ${selectedLink.name === link.name ? 'active' : ''}`}
              onClick={() => setSelectedLink(link)}
            >
              {link.name}
            </li>
          ))}
        </ul>
      </div>

      {/* Right Details Section */}
      <div className="learnabout-details">
        <div className="learnabout-image">
          <img src={selectedLink.image} alt={selectedLink.name} />
        </div>
        <div className="learnabout-info">
          <p className='learnabout-infoName'>{selectedLink.name}</p>
          <p className='learnabout-infoDetails'>{selectedLink.details}</p>
          <div className='learnabout-infoButton'>
          <Button to={selectedLink.url} children={selectedLink.button} />
          </div>
        
        </div>
      </div>
    </div>
   </div>
  );
};

export default LearnAbout;
